// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"640":"e2e464c530efa576","672":"d8ab2a4f9c7d4000"}[chunkId] + ".js";
};